import React, { Component, Suspense } from "react";
import LoginForm from "./components/mainComponents/loginForm";
import Dashboard from "./components/mainComponents/dashboard";
import { Route, Routes, Navigate } from "react-router-dom";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Suspense fallback={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", color: "#6b7280" }}>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    );
  }
}
